import React from 'react';
import { Container } from 'react-bootstrap';
import '../../../assets/css/customer/contact/ContactMap.css';

const ContactMap = () => {
  // Pakistan location - Lahore, Punjab
  // You can replace this with your actual business location in Pakistan
  const mapSrc = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d435519.2274526564!2d74.00472179999999!3d31.5203696!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39190483e58107d9%3A0xc23abe6ccc7e2462!2sLahore%2C%20Punjab%2C%20Pakistan!5e0!3m2!1sen!2s!4v1234567890123!5m2!1sen!2s";

  return (
    <section className="contact-map-section">
      <Container fluid className="contact-map-container">
        {/* Google Map Embed */}
        <div className="contact-map-wrapper">
          <iframe
            src={mapSrc}
            className="contact-map-iframe"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Business Location Map"
          ></iframe>
        </div>
      </Container>
    </section>
  );
};

export default ContactMap;